import React, { useState } from 'react';
import { Input } from 'antd';
import { moneyFormat } from '@portal/utils/format';
import { PixType } from '@portal/enum/pix';
import { PixStatus } from '@portal/enum/PixStatus';
import { translate } from '@portal/services/i18n';
import AdvancedSelect from '../AdvancedSelect/AdvancedSelect';
import ThemedText from '@portal/components/ThemedText/ThemedText';

interface IProps {
  pixKeys?: models.RegisterPixKeyDetails[] | null;
  setPixKey: (value: string) => void;
  setDescription: (value: string) => void;
  amount: number;
}
const QRCodeGenerate = (props: IProps) => {
  const [chosenKey, setChosenKey] = useState<string>('');

  const activeKeys = (props.pixKeys ?? []).filter(
    (pixKey) => pixKey.status === PixStatus.ACTIVE
  );

  const handlePixLabel = (value: number) => {
    if (PixType.EMAIL === value) {
      return translate('PAGES.HOME.PIX.LABELS.EMAIL');
    }
    if (PixType.PHONE === value) {
      return translate('PAGES.HOME.PIX.LABELS.PHONE');
    }
    if (PixType.TAX_IDENTIFIER === value) {
      return translate('PAGES.HOME.PIX.LABELS.TAX_IDENTIFIER');
    }
    if (PixType.RANDOM === value) {
      return translate('PAGES.HOME.PIX.LABELS.RANDOM');
    }
  };

  const handleKeyChange = (key: string) => {
    setChosenKey(key);
    props.setPixKey(key);
  };

  return (
    <div className="qr-code-generate">
      <ThemedText variant="body" className="qr-code-generate__info">
        {translate('PAGES.HOME.PIX.QRCODE.TITLE')}
      </ThemedText>
      {props.amount !== 0 && (
        <ThemedText variant="body" className="qr-code-generate__amount">
          {moneyFormat(props.amount)}
        </ThemedText>
      )}
      <ThemedText variant="body" className="qr-code-generate__chave-pix">
        {translate('PAGES.HOME.PIX.QRCODE.PIX_KEYS_TITLE')}
      </ThemedText>
      {activeKeys.length > 0 ? (
        <AdvancedSelect
          value={chosenKey || activeKeys[0].key}
          variant="outlined"
          onChange={(key) => handleKeyChange(key)}
          options={activeKeys.map((pixKey) => ({
            value: pixKey.key,
            name: `${handlePixLabel(pixKey.type)}: ${pixKey.key}`,
          }))}
        />
      ) : null}
      <Input.TextArea
        rows={3}
        placeholder={translate('PAGES.HOME.PIX.QRCODE.TEXT_BOX_PLACEHOLDER')}
        onChange={(e) => props.setDescription(e.target.value)}
        maxLength={30}
      />
    </div>
  );
};

export default QRCodeGenerate;
